import Auth from '@aws-amplify/auth';
import awsconfig from '@/aws-exports';

export const AUTH_SERVICE = {

  // main.ts
  inicializarConfiguracion() {
    Auth.configure(awsconfig);
  },

  // api-client.ts && index.ts && app.vue
  sesionActual(): Promise<IUserAuthSession> {
    return Auth.currentSession();
  },

  // api-client.ts
  desloguearse(): Promise<void> {
    return Auth.signOut();
  },

  // ModalRegistro.vue
  registrarse(user, pwd): Promise<any>{
    return Auth.signUp({username: user, password: pwd});
  },

  // Login.vue
  loguearse(user, pwd): Promise<IUserAuth>{
    return Auth.signIn(user, pwd);
  },

};

export interface IUserAuth {
  getSignInUserSession(): IUserAuthSession;
}

export interface IUserAuthSession {
  getIdToken(): IAuthIdToken;
  getAccessToken();
}

export interface IAuthIdToken {
  payload?: any;
  getJwtToken(): string;
}